// extracted by mini-css-extract-plugin
export var header = "_49-0";